<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <button
        :class="$style.removeAccountButton"
        @click="modals.accountRemovalConfirmation = true"
      >
        Delete Account
      </button>
    </v-layout>
    <CommonModal
      :display="modals.accountRemovalConfirmation"
      :always-modal="true"
      width="480"
      type="AppendModal"
      title="Delete Account?"
      name="accountRemovalConfirmation"
      @toggleModal="
        modals.accountRemovalConfirmation = !modals.accountRemovalConfirmation
      "
    >
      <ConfirmModalContent
        message="Do you really want to completely delete your account?"
        confirm-text="Yes"
        cancel-text="No"
        @confirm="onAccountDeleteConfirmed"
        @cancel="modals.accountRemovalConfirmation = false"
      />
    </CommonModal>
    <CommonModal
      :display="modals.accountRemoval"
      :always-modal="true"
      width="480"
      type="AppendModal"
      title="Delete Account Completely?"
      name="accountRemoval"
      @toggleModal="modals.accountRemoval = !modals.accountRemoval"
    >
      <ConfirmModalContent
        message="Please enter the verification code sent to your email:"
        confirm-text="Delete"
        cancel-text="Cancel"
        @confirm="onAccountRemovalConfirmed"
        @cancel="modals.accountRemoval = false"
      >
        <v-layout justify-center>
          <v-flex xs8
                  md6>
            <v-layout justify-end>
              <button
                :disabled="secondsUntilNextRemovalRequest > 0"
                :class="$style.resendRemovalCode"
                @click="onAccountRemovalRequested"
              >
                Resend Code?
                <span v-if="secondsUntilNextRemovalRequest">
                  ({{ secondsUntilNextRemovalRequest }}s.)
                </span>
              </button>
            </v-layout>
            <v-text-field
              v-model="accountRemovalCode"
              :error-messages="accountRemovalCodeError"
              label="Code from email"
              autocomplete="one-time-code"
              outline
              @input="accountRemovalCodeError = null"
            />
          </v-flex>
        </v-layout>
      </ConfirmModalContent>
    </CommonModal>
  </div>

</template>
<script>
import { ACCOUNT_REMOVAL_CONFIRMED, ACCOUNT_REMOVAL_REQUESTED } from '@/apps/auth/store/types';
import CommonModal from '@/apps/shared/components/CommonModal';
import ConfirmModalContent from '@/components/ConfirmModalContent';
import Component from 'vue-class-component';
import { Action } from 'vuex-class';

const MS_IN_SEC = 1000;

@Component({
  components: {
    CommonModal,
    ConfirmModalContent,
  },
})
export default class RemoveAccountButton {
  @Action(ACCOUNT_REMOVAL_REQUESTED) requestRemoval;
  @Action(ACCOUNT_REMOVAL_CONFIRMED) confirmRemoval;

  accountRemovalCode = null;
  accountRemovalCodeError = null;
  secondsUntilNextRemovalRequest = 0;
  countdownIntervalId = null;

  modals = {
    accountRemovalConfirmation: false,
    accountRemoval:             false,
  }

  /** Handles account deletion. */
  async onAccountDeleteConfirmed() {
    this.modals.accountRemovalConfirmation = false;
    this.modals.accountRemoval = true;
    await this.onAccountRemovalRequested();
  }

  async onAccountRemovalRequested() {
    try {
      await this.requestRemoval();
      this.initiateCountdown();
    } catch (e) {
      this.accountRemovalCodeError = e.message;
    }
  }

  async onAccountRemovalConfirmed() {
    await this.confirmRemoval(this.accountRemovalCode);
    this.modals.accountRemoval = false;
    this.$router.push({ path: '/', replace: true });
  }

  initiateCountdown(seconds = 60) {
    this.disposeCountdown();
    this.secondsUntilNextRemovalRequest = seconds;

    this.countdownIntervalId = setInterval(() => {
      this.secondsUntilNextRemovalRequest--;

      if (this.secondsUntilNextRemovalRequest === 0) {
        this.disposeCountdown();
      }
    }, MS_IN_SEC);
  }

  disposeCountdown() {
    if (this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
      this.countdownIntervalId = null;
    }
    this.accountRemovalCodeError = null;
  }
}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";

  .removeAccountButton, .resendRemovalCode {
    background-color: transparent;
    border: none;
    font-weight: bold;
    opacity: 0.8;
    padding: 0;
    cursor: pointer;
  }

  .removeAccountButton {
    color: $red-color;
    margin: 20px;
  }

  .removeAccountButton:hover:not(:disabled),
  .resendRemovalCode:hover:not(:disabled) {
    text-decoration: underline;
  }

  .resendRemovalCode {
    color: $blue-color;
  }

  .resendRemovalCode:disabled {
    color: $gray-dark;
  }

</style>



// WEBPACK FOOTER //
// src/components/RemoveAccountButton.vue